
  import { hasPublicApiEnabled } from '@/ui/auth/auth';
  import { Box } from '@/ui/components/Box';
  import PublicApiForbidden from '@/ui/pages/publicApi/PublicApiForbidden.vue';
  import { defineComponent } from 'vue';
  import PublicApiKeyTable from '@/ui/pages/publicApi/PublicApiKeyTable';

  export default defineComponent({
    name: 'PublicApiIndex',
    components: {
      PublicApiForbidden,
      Box,
      PublicApiKeyTable,
    },
    methods: {
      hasPublicApiEnabled,
    },
  });
